import { ActivatedRoute } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

export class BasePage {

    public language;

    constructor(protected route: ActivatedRoute, protected translate: TranslateService) {

        this.language = this.translate.currentLang;

        translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.language = event.lang;
        });

        if (this.route.data) {
            this.route.data.subscribe((data: any) => {
                if (data.language) {
                    this.translate.use(data.language);
                }
            });
        }

    }

}


// WEBPACK FOOTER //
// ./src/app/pages/base.page.ts